import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';

@Component({
  selector: 'skypro-communication-like',
  templateUrl: 'communication-like.html',
  styleUrls: ['communication-like.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DsIconModule],
})
export class CommunicationLikeComponent {
  @Input() likeCount = 0;
  @Input() isLikePressed = false;
  @Input() isDislikePressed = false;
  @Input() isDislikeEnabled = false;

  @Output() like = new EventEmitter<boolean>();
  @Output() dislike = new EventEmitter<void>();

  likeClick(): void {
    this.likeCount += this.isLikePressed ? -1 : 1;
    this.isLikePressed = !this.isLikePressed;

    this.like.emit(this.isLikePressed);
  }

  dislikeClick(): void {
    this.dislike.emit();
  }
}
